var _defs, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            polygon\n            {\n                fill: #263c53;\n            }\n        "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "160.01 76.74 175.51 61.74 46.98 61.74 46.98 196.27 181.5 196.27 181.5 116.83 166.5 131.35 166.5 181.27 61.98 181.27 61.98 76.74 160.01 76.74"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.43 45.21 181.5 76.11 166.5 90.63 123.83 131.93 120.05 135.59 86.29 101.82 75.68 112.43 119.88 156.63 122.35 154.23 166.5 111.5 181.5 96.99 223.87 55.99 223.35 55.45 213.79 45.57 213.43 45.21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnership);
export default __webpack_public_path__ + "static/media/ownership.216017c8b2a75585c60065ecf7cf32ad.svg";
export { ForwardRef as ReactComponent };